﻿import './KPIVisualiser'; // We do this style of import to immediately invoke code within it.

/* istanbul ignore next */
console.log("KPI JavaScript loaded");